import { useCallback } from 'react';
import { Button } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useRcsTemplateEditorState } from '../context/useRcsTemplateEditorContext';
import { useRcsPreview } from '../hooks/useRcsPreview';
import { PreviewInfoPanel, PreviewRequired } from './style';

export const RcsPreviewRequiredView: React.FC = () => {
  const { requiresPreview } = useRcsTemplateEditorState();
  const { t } = useTranslation('designs');
  const { previewTemplate, isLoading } = useRcsPreview();

  const handlePreviewButtonClicked = useCallback(() => {
    previewTemplate();
  }, [previewTemplate]);

  return (
    <PreviewRequired data-testid="RcsPreviewRequiredView">
      <PreviewInfoPanel>
        <Button
          data-testid="RcsPreviewButton"
          variation="primary"
          type="button"
          onClick={handlePreviewButtonClicked}
          disabled={!requiresPreview || isLoading}
        >
          {t('designs:designGallery.templateEditor.previewRequiredView.button.text')}
        </Button>
      </PreviewInfoPanel>
    </PreviewRequired>
  );
};
